<template>
  <v-layout
      column
      wrap
      align-center
      class="white--text"
    >
      <v-container grid-list-xl 
      style="margin-top: 70px">
        <v-layout row wrap align-center>
          <v-flex xs12 sm6 offset-sm3 xl4 offset-xl4 class="my-3">
            <div class="text-xd-center text-md-center login">
              <h2 class="headline mb-0 text-xd-center text-md-center diarioobra"> <span class="diario">Familia Cantu</span></h2>
                
              <v-card class="elevation-12">
                <v-card-text style="padding: 50px 50px 50px 50px">  
                  <v-form @submit.prevent="submit">
                    <h3 class="headline mb-0 text-md-left text-login">Login</h3>
                    <v-flex xs12>
                      <v-layout row wrap >
                        <v-icon dark class="icon-input">perm_identity</v-icon>
                        <v-text-field
                          label="Usuário"
                          v-model="email"
                          class="input-login"
                          hide-details
                          background-color="gray"
                          :error-messages="emailErrors"
                          @input="$v.email.$touch()"
                          @blur="$v.email.$touch()"
                          required
                        ></v-text-field>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout row wrap >
                        <v-icon dark class="icon-input">lock</v-icon>
                        <v-text-field
                          label="Senha"
                          type="password"
                          v-model="password"
                          class="input-login"
                          hide-details
                          background-color="gray"
                          :error-messages="passwordErrors"
                          @input="$v.password.$touch()"
                          @blur="$v.password.$touch()"
                          required
                        ></v-text-field>
                    
                      </v-layout>
                    </v-flex>
                  </v-form>
                </v-card-text>
                <v-card-actions style="padding: 0px 50px 50px 50px;">
                  <v-btn color="primary" block class="text-transform-none" @click="submit">Acessar</v-btn>
                </v-card-actions>
              </v-card>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import store from "@/store";
import usuario from "@/services/usuario";

export default {
  name: 'Signin',
  mixins: [validationMixin],
  data () {
    return {
      title: 'Signin',
      email: '',
      password: ''
    }
  },
  methods: {
    async submit () {
      this.$v.$touch()
      await this.$store.dispatch('signUserIn', {username: this.email, password: this.password})
      let res = await usuario.getUsuario(store.getters.user._id);
      if (res.grand == "Cliente") {
        this.$router.push('/');
      } else {
        this.$router.push('/admin/contatos');
      }
    },
    clear () {
      this.$v.$reset()
      this.email = ''
      this.password = ''
      this.$router.push('/signup')
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  },
  watch: {
    user (value) {
      /*if (value !== null && value !== undefined) {
        this.$router.push('/admin/items')
      }*/
    }
  },
  validations: {
    email: { required, email },
    password: { required }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    emailErrors () {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.email && errors.push('Must be valid e-mail')
      !this.$v.email.required && errors.push('E-mail is required')
      return errors
    },
    passwordErrors () {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.required && errors.push('Password is required')
      return errors
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @font-face {
      font-family: Montserrat-Black;
      src: url("/static/fonts/Montserrat-Black.otf") format("opentype");
  }

  @font-face {
      font-family: Montserrat-Bold;
      src: url("/static/fonts/Montserrat-Bold.otf") format("opentype");
  }

  @font-face {
      font-family: Montserrat-Regular;
      src: url("/static/fonts/Montserrat-Regular.otf") format("opentype");
  }
  html {
    font-family: 'Montserrat-Regular', sans-serif !important;
  }
  v-input {
    font-family: 'Montserrat-Regular', sans-serif !important;
  }
  .banner {
    background-image: url('/static/img/fundo.jpg');
    background-repeat: no-repeat;
    background-position: left top;
    background-size: 100% 150vh;
    max-height: 100%;
    width: 100%;
    height: 150vh !important;
  }
  .input-login {
    background-color: #dadada;
    padding: 10px;
  }

  h1 {
    font-size: 40px !important;
    font-weight: 500;
  }
  h2 {
    font-weight: 500;
  }

  .v-card-title {
    font-weight: 600 !important;
    font-size: 35px !important;
  }

  .hr-title {
    border: none;
    border-top: 6px solid white;
    width: 150px;
    margin-top: 20px;
    margin-bottom: 10px;
  }

  .como-funciona {
    line-height: 0.5;
    text-align: center;
    font-weight: 500;
  }
  .como-funciona span {
    display: inline-block;
    position: relative;  
  }
  .como-funciona span:before,
  .como-funciona span:after {
    content: "";
    position: absolute;
    height: 5px;
    margin-top: 12px;
    border-bottom: 6px solid #00a99d;
    top: 0;
    width: 250px;
  }
  .como-funciona span:before {
    right: 100%;
    margin-right: 15%;
  }
  .como-funciona span:after {
    left: 100%;
    margin-left: 15%;
  }
  .login {
    margin-top: 60px;
  }
  .diarioobra {
    font-size: 40px !important;
    font-family: 'Montserrat-Extra-Bold', sans-serif !important;
    font-weight: 900;
    font-style: normal;
    
    margin-bottom: 20px !important;
  }
  .diario {
    color: #2088b4;
  }
  .text-login {
    color: #2088b4;
    font-family: 'Montserrat-Extra-Bold', sans-serif !important;
    font-size: 50px !important;
    font-weight: 700;
    padding: 10px 10px 30px 10px;
  }
  .icon-input {
    margin-top: 4px;
    background-color: #2088b4;
    width: 50px;
  }
</style>


// WEBPACK FOOTER //
// src/pages/user/Signin.vue